import api from '@/api/index.js'

const account_money_claim = {
  state: {
    loading: false,
    updating: false,
    data: null,
    // createdMoneyClaimId: null,
    // updatedMoneyClaim: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_MONEY_CLAIM_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_MONEY_CLAIM_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_MONEY_CLAIM: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_MONEY_CLAIM_CREATED: (state, response) => {
      state.data = response;
    },
    SET_ACCOUNT_MONEY_CLAIM_ERROR: (state, error) => {
      state.error = error;
    },
  },

  actions: {
    LoadAccountMoneyClaim({commit}, req) {
      commit('SET_ACCOUNT_MONEY_CLAIM', null)
      commit('SET_ACCOUNT_MONEY_CLAIM_LOADING', true)
      commit('SET_ACCOUNT_MONEY_CLAIM_ERROR', null)
      return api.get(`accounts/${req.accountID}/money-claims/${req.moneyClaimID}`)
        .then((response) => {
          commit('SET_ACCOUNT_MONEY_CLAIM', response)
          commit('SET_ACCOUNT_MONEY_CLAIM_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_MONEY_CLAIM_ERROR', error)
          commit('SET_ACCOUNT_MONEY_CLAIM_LOADING', false)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
    CreateAccountMoneyClaim({dispatch, commit}, req) {
      commit('SET_ACCOUNT_MONEY_CLAIM_UPDATING', true)
      commit('SET_ACCOUNT_MONEY_CLAIM_ERROR', null)
      commit('SET_ACCOUNT_MONEY_CLAIM_CREATED', null)
      let payload = {...req.payload};
      payload.amount = Math.round(payload.amount * 100);
      return api.post(`accounts/${req.accountID}/money-claims`, payload)
        .then((response) => {
          commit('SET_ACCOUNT_MONEY_CLAIM_CREATED', response.body)
          commit('SET_ACCOUNT_MONEY_CLAIM_UPDATING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_MONEY_CLAIM_ERROR', error)
          commit('SET_ACCOUNT_MONEY_CLAIM_UPDATING', false);
        })
    },
    UpdateAccountMoneyClaim({dispatch, commit}, req) {
      commit('SET_ACCOUNT_MONEY_CLAIM_UPDATING', true)
      commit('SET_ACCOUNT_MONEY_CLAIM_ERROR', null)
      return api.put(`accounts/${req.accountID}/money-claims/${req.moneyClaimID}`, req.payload)
        .then((response) => {
          commit('SET_ACCOUNT_MONEY_CLAIM_UPDATING', false)
          // if (req.reloadAccount) {
          //   // Refresh User details
          //   dispatch('LoadAccountProfile', req.accountID)
          // }
          // // Refresh User money-claims
          // dispatch('LoadAccountMoneyClaim', req)
          // // Refresh User money-claims
          // dispatch('LoadAccountMoneyClaims', req.accountID)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_MONEY_CLAIM_ERROR', error)
          commit('SET_ACCOUNT_MONEY_CLAIM_UPDATING', false);
        })
    },
  },
}

export default account_money_claim
